import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { PiUserDuotone, PiEnvelopeDuotone, PiLockDuotone } from 'react-icons/pi';
import { useAuth } from '../app/providers/AuthContext';
import Input from '../shared/common/Input';
import Button from '../shared/common/Button';
import './LoginPage.css';

const MIN_PASSWORD_LENGTH = 8;

const RegisterPage = () => {
  const navigate = useNavigate();
  const { register } = useAuth();

  const [formData, setFormData] = useState({
    name: '',
    email: '',
    password: '',
    confirmPassword: '',
  });
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);

  const handleChange = (e) =>
    setFormData((prev) => ({ ...prev, [e.target.name]: e.target.value }));

  const validate = () => {
    const errs = {};
    if (!formData.name.trim()) errs.name = 'Введи имя';
    if (!formData.email.trim()) errs.email = 'Введи email';
    if (formData.password.length < MIN_PASSWORD_LENGTH)
      errs.password = `Минимум ${MIN_PASSWORD_LENGTH} символов`;
    if (formData.password !== formData.confirmPassword)
      errs.confirmPassword = 'Пароли не совпадают';
    return errs;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const errs = validate();
    if (Object.keys(errs).length) { setErrors(errs); return; }

    setErrors({});
    setLoading(true);
    try {
      const result = await register(formData.name, formData.email, formData.password);
      if (result.success) navigate('/dashboard');
      else setErrors({ global: result.error || 'Ошибка регистрации' });
    } catch (err) {
      setErrors({ global: 'Произошла ошибка. Попробуй ещё раз.' });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="bm-auth-page">
      {/* Левая hero-панель */}
      <div className="bm-auth-hero">
        <div className="bm-auth-hero__content">
          <div className="bm-auth-hero__logo">⚡ BetMate</div>
          <h1 className="bm-auth-hero__title">
            Присоединяйся<br />к игре
          </h1>
          <p className="bm-auth-hero__subtitle">
            Регистрация займёт меньше минуты.<br />Начни соревноваться прямо сейчас.
          </p>
          <div className="bm-auth-hero__features">
            <div className="bm-auth-hero__feature">🏠 Создавай комнаты</div>
            <div className="bm-auth-hero__feature">🤝 Приглашай друзей</div>
            <div className="bm-auth-hero__feature">🎖️ Побеждай в пари</div>
          </div>
        </div>
      </div>

      {/* Правая форма */}
      <div className="bm-auth-form-panel">
        <div className="bm-auth-form-wrap bm-animate-in">
          <h2 className="bm-auth-form-wrap__title">Создать аккаунт</h2>
          <p className="bm-auth-form-wrap__subtitle">Заполни форму ниже</p>

          {errors.global && (
            <div className="bm-auth-error">{errors.global}</div>
          )}

          <form onSubmit={handleSubmit} className="bm-auth-form">
            <Input
              label="Имя"
              type="text"
              name="name"
              placeholder="Иван Иванов"
              value={formData.name}
              onChange={handleChange}
              icon={<PiUserDuotone size={16} />}
              error={errors.name}
              required
            />
            <Input
              label="Email"
              type="email"
              name="email"
              placeholder="you@example.com"
              value={formData.email}
              onChange={handleChange}
              icon={<PiEnvelopeDuotone size={16} />}
              error={errors.email}
              required
            />
            <Input
              label="Пароль"
              type="password"
              name="password"
              placeholder="Минимум 8 символов"
              value={formData.password}
              onChange={handleChange}
              icon={<PiLockDuotone size={16} />}
              error={errors.password}
              required
            />
            <Input
              label="Повтори пароль"
              type="password"
              name="confirmPassword"
              placeholder="••••••••"
              value={formData.confirmPassword}
              onChange={handleChange}
              icon={<PiLockDuotone size={16} />}
              error={errors.confirmPassword}
              required
            />
            <Button
              type="submit"
              variant="primary"
              size="lg"
              loading={loading}
              style={{ width: '100%' }}
            >
              Зарегистрироваться
            </Button>
          </form>

          <p className="bm-auth-footer">
            Уже есть аккаунт?{' '}
            <Link to="/login">Войти</Link>
          </p>
        </div>
      </div>
    </div>
  );
};

export default RegisterPage;
